
import { mapGetters, mapState } from 'vuex'
import ProductCardMixin from '@made-people/centra-storyblok-nuxt-shared/lib/mixins/ProductCardMixin'

export default {
  name: 'ProductCardCarousel',
  mixins: [
    ProductCardMixin,
  ],
  props: {
    product: {
      type: Object,
      required: true,
    },
    currentSlide: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    direction: {
      type: String,
      required: true,
    },
    annimateToDisappearIndex: {
      type: Number,
      required: true,
    },
    isFirstTimeLoad: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data () {
    return {
      isAnnimateToDisappear: false,
      touchStartX: null,
      touchEndX: null,
    }
  },
  computed: {
    ...mapGetters({
      pricelist: 'frontend/pricelist',
    }),
    ...mapState({
      isProductDiscontinued: state => state.ui.isProductDiscontinued,
    }),
    name () {
      return this.product.name
    },
    price () {
      return this.product.prices[this.pricelist?.pricelist]?.price || this.product.price
    },
    priceBeforeDiscount () {
      return this.product.prices[this.pricelist?.pricelist]?.priceBeforeDiscount || ''
    },
    isOnSale () {
      return this.product.prices[this.pricelist?.pricelist]?.priceBeforeDiscount !== this.product.prices[this.pricelist?.pricelist]?.price
    },
    animationClass () {
      if (this.isFirstTimeLoad) {
        return ''
      }
      if (this.currentSlide === this.index) {
        return 'adding-direction-' + this.direction
      } else {
        return 'removing-direction-' + this.direction
      }
    },
    sizeOptions () {
      return this.centraProduct?.sizeOptions || []
    },
  },
  watch: {
    annimateToDisappearIndex () {
      if (this.annimateToDisappearIndex === this.index) {
        this.annimateToDisappear()
      }
    },
  },
  methods: {
    annimateToDisappear () {
      this.isAnnimateToDisappear = true
      setTimeout(() => {
        this.isAnnimateToDisappear = false
      }, 680)
    },
    async fetchCentraProduct (productSku) {
      if (this.centraProduct !== null) { return }
      await this.$store.dispatch('centra-product/lookupProductBySku', productSku)
        .then((product) => {
          this.centraProduct = product
        })
        .catch((error) => {
          console.error('Failed to fetch centra product', error)
          this.centraProduct = {}
        })
    },
    fireAtcClickTrackingEvent () {
      this.gtm_trackQuickAddToCartClick({
        sku: this.product?.sku,
        name: this.product?.name,
        variantName: this.product?.variantName,
        price: this.product?.prices?.[this.pricelist.pricelist]?.priceAsNumber,
        isBundle: this.product?.isBundle,
      })
    },
    handleAtcClick () {
      if (this.sizeOptions.length) {
        this.showSizeSelector()
        this.fireAtcClickTrackingEvent()
      } else {
        this.fetchCentraProduct(this.product.sku).then(() => {
          if (this.sizeOptions.length) {
            this.fireAtcClickTrackingEvent()
            this.showSizeSelector()
          }
        })
      }
    },
    showSizeSelector () {
      this.$store.dispatch(
        'ui/showSizeSelectorMobile',
        {
          productID: this.product.objectID,
          discontinued: this.isProductDiscontinued,
          productItems: [],
          isQuickBuy: true,
          // queryID: this.queryID,
        }
      )
    },
    handleTouchStart (e) {
      this.touchStartX = e.changedTouches[0].clientX
    },
    handleTouchEnd (e) {
      this.touchEndX = e.changedTouches[0].clientX
      this.handleSwipeGesture()
    },
    handleSwipeGesture () {
      const swipeThreshold = 50
      const swipeDistance = Math.abs(this.touchEndX - this.touchStartX)
      if (swipeDistance < swipeThreshold) {
        return
      }
      if (this.touchEndX < this.touchStartX) {
        this.$emit('next')
      }
      if (this.touchEndX > this.touchStartX) {
        this.$emit('prev')
      }
    },
  }
}
